import { get, post, put, remove } from "./apiClient";
import { uriWithQueryStringParams } from "../utils/urlUtils";

export default {
  async deleteReportSubscription(id) {
    await remove(
      uriWithQueryStringParams("reportSubscriptions", { subscriptionId: id })
    );
  },

  async getRecipients(facilityId) {
    return await get(
      uriWithQueryStringParams("reportSubscriptions/recipients", { facilityId })
    );
  },

  async getReportTypes(facilityId) {
    return await get(
      uriWithQueryStringParams("reportSubscriptionTypes", { facilityId })
    );
  },

  async getReportSubscription(reportSubscriptionId) {
    return await get(
      uriWithQueryStringParams("reportSubscriptions", {
        subscriptionId: reportSubscriptionId
      })
    );
  },

  async getReportSubscriptionByToken(token) {
    return await get(
      uriWithQueryStringParams("reportSubscriptions", {
        unsubscribeToken: token
      })
    );
  },

  async getSubscriptionsForFacility(facilityId) {
    return await get(
      uriWithQueryStringParams("reportSubscriptions", { facilityId })
    );
  },

  async saveSubscription(reportSubscription) {
    const url = "reportSubscriptions";

    if (reportSubscription.id) {
      return await put(url, reportSubscription);
    } else {
      return await post(url, reportSubscription);
    }
  },

  async unsubscribe(token) {
    await remove(
      `reportSubscriptions/unsubscribe/${encodeURIComponent(token)}`
    );
  }
};
